import '@fullcalendar/react/dist/vdom';
import React from 'react';
import ReactDOM from 'react-dom';
import { applyGlobalStyles } from '@uplift/ui-v2';
import { RootStoreProvider } from '@uplift/providers';
import { RootStore } from '@uplift/store';
import { LocalStorageService } from '@uplift/services';
import { App } from './app/app';
import { environment } from './environments/environment';
import { restClient } from '@uplift/api';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { sentryInit } from '@uplift/contexts';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

applyGlobalStyles();

LocalStorageService.setAppNameSpace(environment.appNameSpace);

const rootStore = RootStore.createRootStore(environment);

if (environment.production && environment.sentryDSN) {
  sentryInit(environment.sentryDSN);
}


restClient.configure({
  apiEndpoint: environment.restApi,
  authClient: rootStore.authClient,
  authStore: rootStore.authStore,
  authRedirectFallback: environment.authUrl,
});
const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      networkMode: 'always',
    },
    queries: {
      networkMode: 'always',
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  }
});

ReactDOM.render(
  <React.StrictMode>
    <RootStoreProvider rootStore={rootStore}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools />
        <App />
      </QueryClientProvider>
    </RootStoreProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
